module.exports = __webpack_public_path__ + "img/18.c9b3b648.png";